import i18n from '../../i18n';

const VissionData = [
    {
        id: 1,
        text: i18n.t('data2.vision1')
    },
    {
        id: 2,
        text: i18n.t('data2.vision2')
    },
    {
        id: 3,
        text: i18n.t('data2.vision3')
    },
    {
        id: 4,
        text: i18n.t('data2.vision4')
    },
    {
        id: 5,
        text: i18n.t('data2.vision5')
    }
]

export default VissionData;